import * as Yup from 'yup';

const phoneRegExp = /^\s*((?:[+](?:\s?\d)(?:[-\s]?\d)|0)?(?:\s?\d)(?:[-\s]?\d){9}|[(](?:\s?\d)(?:[-\s]?\d)+\s*[)](?:[-\s]?\d)+)\s*$/;

const DetailsSchema = Yup.object().shape({
    addressLine1: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    postCode: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    country: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required')
});

const InfoSchema = Yup.object().shape({
    firstName: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    lastName: Yup.string()
        .min(2, 'Too Short!')
        .max(50, 'Too Long!')
        .required('Required'),
    phone: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
    organisation: Yup.string()
        .ensure()
        .when('customerType', {
            is: 'organisation',
            then: Yup.string().required()
        })
});

const SUPPORTED_FORMATS = ['png', 'jpg', 'pdf'];
const supportingDoucmentsValidations = Yup.object().shape({
    document: Yup.mixed()
        .test(
            'fileSize',
            'File too large',
            value => value === null || (value && value.size <= 262144000)
        )
        .test(
            'fileFormat',
            'Unsupported file type',
            value => value === null || (value && SUPPORTED_FORMATS.includes(value.type))
        ),
    dateSale: Yup.date()
        .min(new Date())
        // .max(new Date('01-01-2050'))
        .required()
});

export default {
    DetailsSchema,
    InfoSchema,
    supportingDoucmentsValidations
};
